import {
    RE_STORE_ALL,
    RE_STORE_HOUSE,
    RE_REMOVE_HOUSE,
    RE_STORE_PARTNER,
    RE_REMOVE_PARTNER,
} from '../../constants/realEstate';

const initialState = {
    partners: [],
    houses: [],
    addableUsers: [],
    currentPersonId: null,
    role: null,
    canSeeAll: false,
};

const upsert = (list, item, key) => {
    const idx = list.findIndex((l) => l[key] === item[key]);
    if (idx === -1) return [...list, item];
    const next = list.slice();
    next[idx] = item;
    return next;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case RE_STORE_ALL:
            return {
                ...state,
                partners: action.payload?.partners || [],
                houses: action.payload?.houses || [],
                addableUsers: action.payload?.addableUsers || [],
                currentPersonId: action.payload?.currentPersonId || state.currentPersonId,
                role: action.payload?.role ?? state.role,
                canSeeAll: action.payload?.canSeeAll ?? state.canSeeAll,
            };

        case RE_STORE_HOUSE:
            return {
                ...state,
                houses: upsert(state.houses, action.house, 'id'),
            };

        case RE_REMOVE_HOUSE:
            return {
                ...state,
                houses: state.houses.filter((h) => h.id !== action.houseId),
            };

        case RE_STORE_PARTNER:
            return {
                ...state,
                partners: upsert(state.partners, action.partner, 'personId'),
            };

        case RE_REMOVE_PARTNER:
            return {
                ...state,
                partners: state.partners.filter((p) => p.personId !== action.personId),
            };

        default:
            return state;
    }
};
